<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">



    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'PurchaseReport',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
